import { uniqid } from '@/utils'
import _ from 'lodash'

export default class FieldItem {
  value
  fields
  _field

  constructor (value, fields, field) {
    this._uid = uniqid()
    this.value = value
    this.fields = fields
    this._field = field
  }

  getUID () {
    return this._uid
  }

  getTitle () {
    return _.get(this.value, this.field.options.title_field) || this.index
  }

  getField (identifier) {
    return this.fields.find(field => field.identifier === identifier)
  }

  set index (value) {
    this.value.index = value
  }

  get index () {
    return this.value.index
  }

  get field () {
    return this._field
  }
}
